import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/videos';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '电视剧', path: '/category/dianshiju' },
    { label: '电影', path: '/category/dianying' },
    { label: '动漫', path: '/category/dongman' },
    { label: '综艺', path: '/category/zongyi' },
    { label: '纪录片', path: '/category/jilupian' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '品牌介绍', path: '/about' },
    { label: '联系方式', path: '/about' },
    { label: '用户口碑', path: '/about' },
  ],
  help: [
    { label: '常见问题', path: '/about' },
    { label: '观看指南', path: '/about' },
    { label: '意见反馈', path: '/about' },
    { label: '版权声明', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-fill text-background-50 text-xl"></i>
                </span>
                <span className="text-xl font-heading font-bold text-background-50">
                  人人影视
                </span>
              </Link>
              <p className="text-sm leading-relaxed text-background-50/60 mb-4 max-w-xs">
                {siteInfo.slogan}。汇聚海量免费影视资源，高清画质免付费，即点即看。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.navigation.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">关于</h3>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.about.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">帮助</h3>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.help.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 人人影视高清免费在线观看
            </p>
            <div className="flex items-center gap-4 text-xs text-background-50/40">
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}